import { type FC } from 'react';
import Icon, { type IconIds } from 'src/common/components/IconDS22';
import { useTranslation } from 'next-i18next';
import styles from './ClearButton.module.scss';

type ClearButtonProps = {
  onClick: () => void;
  onFocus?: () => void;
  onBlur?: () => void;
  closeIconId: IconIds;
};
const ClearButton: FC<ClearButtonProps> = ({
  onClick, onFocus, onBlur, closeIconId,
}) => {
  const { t } = useTranslation('common');

  return (
    <button
      onClick={onClick}
      type="button"
      aria-label={t('aria-input-location')}
      onFocus={onFocus}
      onBlur={onBlur}
      className={styles.root}
    >
      <Icon
        id={closeIconId}
        size="l"
        className={styles.icon}
      />
    </button>
  );
};

export default ClearButton;
